<template>
    <b-card no-body>
        <b-card-header>
            <span class="h5">
                PRÉ-CONTRATO -
                <b-badge variant="warning">{{ operacao }}</b-badge>
            </span>
        </b-card-header>
        <b-card-body>
            <app-erros-box
                :erros="todosOsErros"
                v-if="todosOsErros.length > 0"
            ></app-erros-box>
            <div>
                <b-row>
                    <b-col sm="12" md="8">
                        <b-row>
                            <b-col sm="12" md="3">
                                <b-form-group>
                                    <label for="numeroContrato"
                                        class="required"
                                        >Código do contrato</label
                                    >
                                    <b-input-group>
                                        <b-form-input
                                            type="text"
                                            id="numeroContrato"
                                            placeholder="Ex: 111/1111/XXXX"
                                            v-model="preContratoDto.vcCodigoEstruturado"
                                            v-mask="'###/####/XXXX'"
                                            max="13"
                                            @input="$v.preContratoDto.vcCodigoEstruturado.$touch()"
                                            :state="
                                                $v.preContratoDto.vcCodigoEstruturado.$error
                                                    ? false
                                                    : null
                                            "
                                            :disabled="!habilitaCampos"
                                        ></b-form-input>
                                        <b-form-invalid-feedback
                                            >Código do contrato é obrigatório</b-form-invalid-feedback
                                        >
                                    </b-input-group>
                                </b-form-group>
                            </b-col>
                            <b-col sm="12" md="3">
                                <b-form-group>
                                    <label for="tipoContratacao"
                                        class="required"
                                        >Tipo da contratação</label
                                    >
                                    <b-form-select
                                        class="mb-2 mr-sm-2 mb-sm-0"
                                        :plain="true"
                                        :options="tiposContratacao"
                                        text-field="descricao"
                                        value-field="id"
                                        v-model="preContratoDto.tpContratacao"
                                        @change="selecionaTipoContratacao($event)"
                                        :disabled="edicaoPreContrato || !habilitaCampos"
                                    ></b-form-select>
                                </b-form-group>
                            </b-col>
                            <b-col sm="12" md="3" v-if="!isTermoCadastramento">
                                <b-form-group>
                                    <label for="tipoLicitacao" class="required">
                                        Tipo da Licitação
                                    </label>
                                    <b-form-select
                                        class="mb-2 mr-sm-2 mb-sm-0"
                                        :plain="true"
                                        :options="tiposLicitacao"
                                        text-field="descricao"
                                        value-field="id"
                                        v-model="preContratoDto.codTipoLicitacao"
                                        @change="mudarLabelReferenteLicitacao($event)"
                                        :disabled="!habilitaCampos"
                                    ></b-form-select>
                                </b-form-group>
                            </b-col>
                            <b-col sm="12" md="3" v-if="!isTermoCadastramento">
                                <b-form-group>
                                    <label for="numRef" class="required"
                                        >Número {{ tipoLicitacaoSelecionado }}
                                    </label>
                                    <b-input-group>
                                        <b-form-input
                                            type="text"
                                            id="numRef"
                                            placeholder="Ex: 111/1111-XXX"
                                            v-model="
                                                preContratoDto.numProcessoLicitacao
                                            "
                                            v-mask="'###/####-XXX'"
                                            @input="onNumeroLicitacaoInput"
                                            :state="
                                                $v.preContratoDto.numProcessoLicitacao.$error
                                                    ? false
                                                    : null
                                            "
                                            :disabled="!habilitaCampos"
                                        ></b-form-input>
                                        <b-form-invalid-feedback
                                            >Número {{ tipoLicitacaoSelecionado }} é obrigatório</b-form-invalid-feedback
                                        >
                                    </b-input-group>
                                </b-form-group>
                            </b-col>
                            <b-col sm="12" md="3" v-if="mostraFormaAutorizacao">
                                <b-form-group>
                                    <label
                                        v-show="mostraFormaAutorizacao"
                                        for="formaAutorizacao"
                                        class="required"
                                        >Forma de Autorização</label
                                    >
                                    <b-form-select
                                        class="mb-2 mr-sm-2 mb-sm-0"
                                        :plain="true"
                                        :options="formasAutorizacao"
                                        v-model="preContratoDto.formaAutorizacao"
                                        v-show="mostraFormaAutorizacao"
                                        :disabled="!habilitaCampos"
                                    ></b-form-select>
                                </b-form-group>
                            </b-col>
                            <b-col sm="12" md="3" v-if="mostraFormaAutorizacao">
                                <b-form-group
                                    :state="
                                        $v.preContratoDto.dataAutorizacaoMapa.$error
                                            ? false
                                            : null
                                    "
                                    invalid-feedback="Data da autorização é obrigatória"
                                >
                                    <label v-show="mostraFormaAutorizacao"
                                        class="required"
                                        >Data Autorização</label
                                    >
                                    <date-picker
                                        v-model="preContratoDto.dataAutorizacaoMapa"
                                        :config="$datePickerOptions"
                                        v-mask="'##/##/####'"
                                        @input.native="
                                            $v.preContratoDto.dataAutorizacaoMapa.$touch()
                                        "
                                        v-show="mostraFormaAutorizacao"
                                        :disabled="!habilitaCampos"
                                    ></date-picker>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <b-row class="mb-2">
                            <b-col sm="12">
                                <b-form-checkbox
                                    v-model="temBoletimMedicao"
                                    :disabled="!habilitaCampos"
                                >
                                    Este contrato prevê boletins de medição?
                                </b-form-checkbox>
                            </b-col>
                        </b-row>

                        <b-row>
                            <b-col sm="12" md="4">
                                <b-form-group>
                                    <label for="cpfcnpj"
                                        class="required"
                                    >CPF/CNPJ Formecedor</label>
                                    <b-input-group>
                                        <b-form-input
                                            type="text"
                                            id="cpfcnpj"
                                            placeholder="Digite o CPF ou CNPJ do fornecedor"
                                            v-model="fornecedor.cnpjcpf"
                                            v-mask="[
                                                '###.###.###-##',
                                                '##.###.###/####-##'
                                            ]"
                                            @input="onCpfCnpjInput"
                                            :state="
                                                $v.fornecedor.cnpjcpf.$error
                                                    ? false
                                                    : null
                                            "
                                            :disabled="!habilitaCampos"
                                        ></b-form-input>
                                        <b-input-group-append>
                                            <b-button
                                                variant="primary"
                                                @click="pesquisarFornecedor()"
                                                title="Clique para pesquisar o fornecedor"
                                                :disabled="!habilitaCampos"
                                            >
                                                <i class="fa fa-search"></i>
                                            </b-button>
                                        </b-input-group-append>
                                        <b-form-invalid-feedback
                                            >O CPF ou CNPJ do fornecedor é obrigatório</b-form-invalid-feedback
                                        >
                                    </b-input-group>
                                </b-form-group>
                            </b-col>
                            <b-col sm="12" md="8">
                                <b-form-group>
                                    <label for="razaoSocial"
                                        class="required"
                                    >Razão social</label>
                                    <b-input-group>
                                        <b-form-input
                                            type="text"
                                            id="razaoSocial"
                                            v-model="fornecedor.razaoSocial"
                                            :disabled="true"
                                            @input="$v.fornecedor.razaoSocial.$touch()"
                                            :state="
                                                $v.fornecedor.razaoSocial.$error
                                                    ? false
                                                    : null
                                            "
                                        ></b-form-input>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-col>

                    <b-col sm="12" md="4" class="publicacao-coluna">
                        <b-form-group
                            :state="$v.preContratoDto.dataDePublicacaoDoDOE.$error ? false : null"
                            invalid-feedback="Data de publicação do DOE é obrigatótio"
                            class="mb-0"
                        >
                            <label class="required">Data de publicação do DOE</label>
                            <date-picker
                                v-model="preContratoDto.dataDePublicacaoDoDOE"
                                :config="$datePickerOptions"
                                v-mask="'##/##/####'"
                                @input.native="$v.preContratoDto.dataDePublicacaoDoDOE.$touch()"
                                :disabled="!habilitaCampos"
                            ></date-picker>
                        </b-form-group>

                        <div class="publicacao-anexo-item">
                            <b-form-group class="flex-grow-1 mb-0">
                                <label class="required">Anexo DOE</label>
                                <b-form-file
                                    v-model="preContratoDto.arquivoAnexoDoDOE"
                                    :placeholder="placeholderDOE"
                                    ref="documentoInputDOE"
                                    browse-text="Selecionar"
                                    accept="application/pdf"
                                    @input="onAnexoInput($event, 'arquivoAnexoDoDOE', 'documentoInputDOE')"
                                    :state="$v.preContratoDto.arquivoAnexoDoDOE.$error ? false : null"
                                    :disabled="!habilitaCampos"
                                ></b-form-file>
                                <b-form-invalid-feedback v-if="!$v.preContratoDto.arquivoAnexoDoDOE.required">
                                    Anexo DOE é obrigatório
                                </b-form-invalid-feedback>
                            </b-form-group>
                            <span
                                v-if="placeholderDOE != 'Selecione o Anexo...' && textoBotao == 'Atualizar'"
                                class="text-primary ml-2 mt-2">
                                <i
                                    class="fa fa-download fa-lg icon-button"
                                    title="Download Anexo DOE"
                                    @click.stop="downloadAnexoDoe()"
                                ></i>
                            </span>
                        </div>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col sm="12" md="8">
                        <b-row>
                            <b-col sm="12" md="12">
                                <b-form-group>
                                    <label
                                        class="required"
                                    >Objeto do Contrato</label>
                                    <b-form-textarea
                                        v-model="preContratoDto.vcObjetoContrato"
                                        :rows="5"
                                        maxlength="1000"
                                        @input="
                                            $v.preContratoDto.vcObjetoContrato.$touch()
                                        "
                                        :state="
                                            $v.preContratoDto.vcObjetoContrato.$error
                                                ? false
                                                : null
                                        "
                                        :disabled="!habilitaCampos"
                                    ></b-form-textarea>
                                    <small class="d-block text-right text-muted">
                                        {{ (preContratoDto.vcObjetoContrato || '').length }}/1000
                                    </small>
                                    <b-form-invalid-feedback
                                        v-if="!$v.preContratoDto.vcObjetoContrato.required"
                                    >
                                        O nome do contrato é obrigatório
                                    </b-form-invalid-feedback>
                                    <b-form-invalid-feedback
                                        v-else-if="!$v.preContratoDto.vcObjetoContrato.maxLength"
                                    >
                                        O objeto do contrato deve ter no máximo 1000 caracteres
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-col>

                    <b-col sm="12" md="4" class="publicacao-coluna">
                        <b-form-group class="mb-0">
                            <label>Data de publicação do DOU</label>
                            <date-picker
                                v-model="preContratoDto.dataDePublicacaoDoDOU"
                                :config="$datePickerOptions"
                                v-mask="'##/##/####'"
                                :disabled="!habilitaCampos"
                            ></date-picker>
                        </b-form-group>

                        <div class="publicacao-anexo-item">
                            <b-form-group class="flex-grow-1 mb-0">
                                <label>Anexo DOU</label>
                                <b-form-file
                                    v-model="preContratoDto.arquivoAnexoDoDOU"
                                    :placeholder="placeholderDOU"
                                    ref="documentoInputDOU"
                                    browse-text="Selecionar"
                                    accept="application/pdf"
                                    @input="onAnexoInput($event, 'arquivoAnexoDoDOU', 'documentoInputDOU')"
                                    :state="$v.preContratoDto.arquivoAnexoDoDOU.$error ? false : null"
                                    :disabled="!habilitaCampos"
                                ></b-form-file>
                            </b-form-group>
                            <span
                                v-if="placeholderDOU != 'Selecione o Anexo...' && textoBotao == 'Atualizar'"
                                class="text-primary ml-2 mt-2">
                                <i
                                    class="fa fa-download fa-lg icon-button"
                                    title="Download Anexo DOU"
                                    @click.stop="downloadAnexoDou()"
                                ></i>
                            </span>
                        </div>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col sm="12" md="4">
                        <b-form-group>
                            <label class="required">Data da Proposta</label>
                            <date-picker
                                v-model="preContratoDto.dataDaProposta"
                                :config="$datePickerOptions"
                                v-mask="'##/##/####'"
                            ></date-picker>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="4">
                        <b-form-group>
                            <label>CNO</label>
                            <b-form-input
                                type="text"
                                v-model="preContratoDto.CNO"
                                placeholder="Digite o CNO"
                                maxlength="12"
                                v-mask="'############'"
                                :disabled="!habilitaCampos"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="4">
                        <b-form-group>
                            <label>ART</label>
                            <b-form-input
                                type="text"
                                v-model="preContratoDto.ART"
                                placeholder="Digite o ART"
                                maxlength="13"
                                :disabled="!habilitaCampos"
                                v-mask="'XXXXXXXXXXXXX'"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col sm="12" md="3">
                        <b-form-group>
                            <label for="cpfcnpj"
                                class="required"
                            >CPF/CNPJ Fornecedor</label>
                            <b-input-group>
                                <b-form-input
                                    type="text"
                                    id="cpfcnpj"
                                    placeholder="Digite o CPF ou CNPJ do fornecedor"
                                    v-model="fornecedor.cnpjcpf"
                                    v-mask="[
                                        '###.###.###-##',
                                        '##.###.###/####-##'
                                    ]"
                                    @input="$v.fornecedor.cnpjcpf.$touch()"
                                    :state="
                                        $v.fornecedor.cnpjcpf.$error
                                            ? false
                                            : null
                                    "
                                    :disabled="!habilitaCampos"
                                ></b-form-input>
                                <b-input-group-append>
                                    <b-button
                                        variant="primary"
                                        @click="pesquisarFornecedor()"
                                        title="Clique para pesquisar o fornecedor"
                                        :disabled="!habilitaCampos"
                                    >
                                        <i class="fa fa-search"></i>
                                    </b-button>
                                </b-input-group-append>
                                <b-form-invalid-feedback
                                    >O CPF ou CNPJ do fornecedor é
                                    obrigatório</b-form-invalid-feedback
                                >
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="5">
                        <b-form-group>
                            <label for="razaoSocial"
                                class="required"
                            >Razão social</label>
                            <b-input-group>
                                <b-form-input
                                    type="text"
                                    id="razaoSocial"
                                    v-model="fornecedor.razaoSocial"
                                    :disabled="true"
                                    @input="$v.fornecedor.razaoSocial.$touch()"
                                    :state="
                                        $v.fornecedor.razaoSocial.$error
                                            ? false
                                            : null
                                    "
                                ></b-form-input>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                </b-row>
                <!-- <b-row>
                    <b-col sm="12" md="12">
                        <label for="tblItensContrato"
                            class="required"
                        >Itens do contrato</label>
                        <app-tabela
                            idTabela="tblItensContrato"
                            :itens="preContratoDto.itensContrato"
                            :campos="campos"
                            :itensPorPagina="itensPorPagina"
                        >
                            <template slot="botoes">
                                <div class="d-flex flex-row-reverse mb-3">
                                    <btn-inserir-item-contrato
                                        v-on:salvarItemContrato="
                                            salvarItemContrato
                                        "
                                        :desativarBotao="!habilitaCampos||!camposVazios"
                                        v-if="permiteEditarExcluir"
                                    ></btn-inserir-item-contrato>
                                </div>
                            </template>
                            <template slot="acoes" slot-scope="data">
                                <btn-editar-item-contrato
                                    :parentData="data"
                                    :desativarBotao="!habilitaCampos"
                                    v-on:editarItemContrato="
                                        atualizarItemContrato
                                    "
                                    v-if="permiteEditarExcluir"
                                ></btn-editar-item-contrato>
                                <span class="text-danger float-left mr-2" v-if="permiteEditarExcluir">
                                    <i
                                        class="fa fa-trash fa-lg icon-button"
                                        title="Excluir item contrato"
                                        @click.stop="
                                            confirmarRemocaoItemContrato(data)
                                        "
                                    ></i>
                                </span>
                                <btn-inserir-Subitem
                                    :parentData="data"
                                    :subItens="subItens"
                                    :situacaoContrato="preContratoDto.idSituacaoContrato"
                                    class="mr-2"
                                >
                                </btn-inserir-Subitem>
                                <btn-importar-SubItens
                                    :itemContrato="data"
                                    :desativarBotao="!habilitaCampos"
                                    v-on:subItens="quantidadeSubItens"
                                    v-if="permiteEditarExcluir"
                                >
                                </btn-importar-SubItens>
                            </template>
                            <template slot="valor" slot-scope="data">
                                <span class="text-nowrap">{{
                                    data.valorUnitario | currency
                                }}</span>
                            </template>
                        </app-tabela>
                    </b-col>
                </b-row> -->

                <b-row>
                    <b-col sm="12">
                        <b-form-group>
                            <label>Referência</label>
                            <b-form-textarea
                                v-model="preContratoDto.vcReferencia"
                                :rows="2"
                                maxlength="500"
                                :disabled="!habilitaCampos"
                            ></b-form-textarea>
                            <small class="d-block text-right text-muted">
                                {{ (preContratoDto.vcReferencia || '').length }}/500
                            </small>
                        </b-form-group>
                    </b-col>
                </b-row>
            </div>
            <hr class="my-4" />
            <div>
                <label class="h6">Gestão de Acesso</label>
                <b-row class="mt-3">
                    <b-col sm="12" md="6" lg="6" xl="6">
                        <b-alert show>USUÁRIOS ASSOCIADOS</b-alert>
                        <div class="tabela-usuarios-container">
                            <app-tabela
                                idTabela="tblUsuariosAssociados"
                                :itens="usuariosAssociados"
                                :campos="camposUsuariosAssociados"
                                :itensPorPagina="0"
                            >
                                <template slot="botoes">
                                    <b-button-group class="float-right">
                                        <b-button
                                            variant="danger"
                                            @click="desassociarSelecionados()"
                                            :disabled="
                                                usuariosAssociadosSelecionados.length === 0
                                            "
                                            >Desassociar selecionados</b-button
                                        >
                                    </b-button-group>
                                </template>
                                <template slot="HEAD_usuarioAssociadoSelecao">
                                    <i
                                        class="fa fa-check-square fa-lg text-muted icon-button p-0 m-0"
                                        title="Marcar/Desmarcar todos"
                                        @click.stop="marcarDesmarcarTodosAssociados()"
                                    ></i>
                                </template>
                                <template
                                    slot="usuarioAssociadoSelecao"
                                    slot-scope="data"
                                >
                                    <b-form-checkbox
                                        :value="data.usuarioId"
                                        v-model="usuariosAssociadosSelecionados"
                                    ></b-form-checkbox>
                                </template>
                            </app-tabela>
                        </div>
                    </b-col>
                    <b-col sm="12" md="6" lg="6" xl="6">
                        <b-alert show>USUÁRIOS DISPONÍVEIS</b-alert>
                        <div class="tabela-usuarios-container">
                            <app-tabela
                                idTabela="tblUsuariosDisponiveis"
                                :itens="usuariosDisponiveis"
                                :campos="camposUsuariosDisponiveis"
                                :itensPorPagina="0"
                            >
                                <template slot="botoes">
                                    <b-button-group class="float-right">
                                        <b-button
                                            variant="primary"
                                            @click="associarSelecionados()"
                                            :disabled="
                                                usuariosDisponiveisSelecionados.length === 0
                                            "
                                            >Associar selecionados</b-button
                                        >
                                    </b-button-group>
                                </template>
                                <template slot="HEAD_usuarioDisponivelSelecao">
                                    <i
                                        class="fa fa-check-square fa-lg text-muted icon-button p-0 m-0"
                                        title="Marcar/Desmarcar todos"
                                        @click.stop="marcarDesmarcarTodosDisponiveis()"
                                    ></i>
                                </template>
                                <template
                                    slot="usuarioDisponivelSelecao"
                                    slot-scope="data"
                                >
                                    <b-form-checkbox
                                        :value="data.usuarioId"
                                        v-model="usuariosDisponiveisSelecionados"
                                    ></b-form-checkbox>
                                </template>
                            </app-tabela>
                        </div>
                    </b-col>
                </b-row>
            </div>
        </b-card-body>
        <b-card-footer>
            <b-button
                variant="primary"
                @click.stop="salvarForm()"
                :disabled="!habilitarSalvar || !habilitaCampos"
                class="mr-2"
                v-if="permiteEditarExcluir"
            >
                <i class="fa fa-save"></i>
                {{ textoBotao }}
            </b-button>
            <b-button variant="danger" @click.stop="cancelar()" class="mr-2">
                <span> <i class="fa fa-history mr-2"></i> Voltar </span>
            </b-button>
            <div class="float-right">
                <b-button
                    variant="success"
                    @click.stop="confirmarConcluir()"
                    :disabled="!habilitarSalvar || !habilitaCampos"
                    v-if="$temAcessoView('CONT-PRE-02') && permiteEditarExcluir"
                >
                    <span> <i class="fa fa-check"></i> Concluir </span>
                </b-button>
            </div>
        </b-card-footer>
    </b-card>
</template>

<script>
import BtnInserirItemContrato from './BtnInserirItemContrato'
import BtnEditarItemContrato from './BtnEditarItemContrato'
import BtnInserirSubitem from './BtnInserirSubItem'
import BtnImportarSubItens from './BtnImportarSubItens'
import { required, maxLength } from 'vuelidate/lib/validators'
import PreContratoServicos from './PreContratoServicos'
import { situacaoContrato } from '../SituacaoContrato'
import { formasAutorizacao } from '../FormasAutorizacao'
import UsuariosServicos from '../../ctrlacesso/usuarios/UsuariosServicos'

export default {
    components: {
        BtnInserirItemContrato,
        BtnEditarItemContrato,
        BtnInserirSubitem,
        BtnImportarSubItens
    },

    data() {
        return {
            erros: [],
            erroLicitacao: null,
            erroFornecedor: null,
            contrato: {},
            preContratoDto: {
                idContrato: '00000000-0000-0000-0000-000000000000',
                vcCodigoEstruturado: '',
                tpContratacao: 2,
                nuSaldoContrato: 0,
                nuValorGlobalContrato: 0,
                codTipoLicitacao: 1,
                dataAutorizacaoMapa: null,
                vcObjetoContrato: '',
                vcReferencia: '',
                formaAutorizacao: 0,
                numeroMapa: '',
                codFornecedor: '',
                nomeFornecedor: '',
                vcProcessoAditivo: '',
                itensContrato: [],
                numProcessoLicitacao: '',
                idSituacaoContrato: situacaoContrato.PRE_CONTRATO_EM_ELABORACAO,
                usrLoginCadastro: this.$store.getters.usuario.login,

                dataDePublicacaoDoDOE: '',
                dataDePublicacaoDoDOU: '',
                arquivoAnexoDoDOE: '',
                nomeAnexoDoDOE: '',
                arquivoAnexoDoDOU: '',
                nomeAnexoDoDOU: '',
                CNO: '',
                ART: '',
                usuarios: []
            },
            placeholderDOU: 'Selecione o Anexo...',
            placeholderDOE: 'Selecione o Anexo...',
            operacao: 'INSERIR',
            textoBotao: 'Salvar',
            tiposContratacao: [],
            tiposContratacaoRemovidos: [
                { "id": 1, "descricao": "Proposta com aceite" },
                { "id": 3, "descricao": "Mapa Comparativo" },
                { "id": 4, "descricao": "Autorização Direta" },
                { "id": 5, "descricao": "Termo de Cadastramento" },
            ],
            tiposLicitacao: [],
            tiposLicitacaoMantidos: [
                { "id": 1, "descricao": "Pregão" },
                { "id": 2, "descricao": "Convite" },
                { "id": 3, "descricao": "Concorrência" },
                { "id": 4, "descricao": "Dispensa" },
                { "id": 5, "descricao": "Inexibilidade" },
                { "id": 7, "descricao": "Concurso" },
                { "id": 28, "descricao": "Procedimento próprio" },
            ],
            tipoLicitacao: 1,
            tipoLicitacaoSelecionado: 'Pregão',
            formasAutorizacao: formasAutorizacao,
            mostraFormaAutorizacao: false,
            edicaoPreContrato: false,
            numeroProcesso: 1,
            numeroMapa: '',
            fornecedor: {
                cnpjcpf: '',
                razaoSocial: ''
            },
            cnpjcpfFornecedor: '',
            mostraNumeroMapa: false,
            mostraPesquisaAtaESelecaoDeProcesso: true,
            campos: [
                {
                    key: 'descricao',
                    label: 'Descrição',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'descricaoResumida',
                    label: 'Descrição resumida',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'valor',
                    label: 'Valor',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap text-right'
                },
                {
                    key: 'quantidade',
                    label: 'Quantidade',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap text-right'
                },
                {
                    key: 'acoes',
                    label: 'Ações'
                }
            ],
            itensPorPagina: 5,
            selecionado: [],
            habilitaCampos: true,
            subItens: [],
            preContratoSalvo: false,
            redirecionarParaDetalharAoConcluir: false,
            fornecedorLicitacaoValido: null,
            fornecedorLicitacaoConflito: false,
            verificandoLicitacao: false,
            temBoletimMedicao: true,
            usuarios: [],
            usuariosAssociados: [],
            usuariosAssociadosSelecionados: [],
            usuariosDisponiveisSelecionados: [],
            camposUsuariosAssociados: [
                {
                    key: 'usuarioAssociadoSelecao',
                    label: ''
                },
                {
                    key: 'nome',
                    label: 'Nome',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'login',
                    label: 'Login',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'email',
                    label: 'Email',
                    sortable: true,
                    filterable: true
                }
            ],
            camposUsuariosDisponiveis: [
                {
                    key: 'usuarioDisponivelSelecao',
                    label: ''
                },
                {
                    key: 'nome',
                    label: 'Nome',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'login',
                    label: 'Login',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'email',
                    label: 'Email',
                    sortable: true,
                    filterable: true
                }
            ]
        }
    },

    methods: {

        redirecionarParaDetalharSeConcluir() {
            if (!this.redirecionarParaDetalharAoConcluir) {
                return
            }

            this.redirecionarParaDetalharAoConcluir = false
            this.$router.push({
                name: 'Contratos_Detalhar',
                params: {
                    contratoId: this.preContratoDto.idContrato
                }
            })
        },

        obterUsuarios() {
            this.$store.dispatch('addRequest')
            UsuariosServicos.obterTodos().then(response => {
                if (response) {
                    if (response.success) {
                        this.usuarios = response.data
                    } else {
                        this.$toast.error(
                            response.errors,
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        associarSelecionados() {
            if (this.usuariosDisponiveisSelecionados.length === 0) {
                return
            }

            if (this.$route.params.contratoId) {
                this.$store.dispatch('addRequest')
                PreContratoServicos.associarUsuarios(
                    this.$route.params.contratoId,
                    this.usuariosDisponiveisSelecionados
                ).then(response => {
                    if (response) {
                        if (response.success) {
                            this.usuariosDisponiveisSelecionados.forEach(usuarioId => {
                                const usuario = this.usuarios.find(u => u.usuarioId === usuarioId)
                                if (usuario && !this.usuariosAssociados.some(u => u.usuarioId === usuarioId)) {
                                    this.usuariosAssociados.push(usuario)
                                }
                            })
                            this.usuariosDisponiveisSelecionados = []
                            this.$toast.success(
                                'Usuários associados com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )
                        } else {
                            this.$toast.error(
                                response.errors,
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
            } else {
                this.usuariosDisponiveisSelecionados.forEach(usuarioId => {
                    const usuario = this.usuarios.find(u => u.usuarioId === usuarioId)
                    if (usuario && !this.usuariosAssociados.some(u => u.usuarioId === usuarioId)) {
                        this.usuariosAssociados.push(usuario)
                    }
                })

                this.usuariosDisponiveisSelecionados = []
            }
        },

        desassociarSelecionados() {
            if (this.usuariosAssociadosSelecionados.length === 0) {
                return
            }

            if (this.$route.params.contratoId) {
                this.$store.dispatch('addRequest')
                PreContratoServicos.desassociarUsuarios(
                    this.$route.params.contratoId,
                    this.usuariosAssociadosSelecionados
                ).then(response => {
                    if (response) {
                        if (response.success) {
                            this.usuariosAssociados = this.usuariosAssociados.filter(
                                usuario => !this.usuariosAssociadosSelecionados.includes(usuario.usuarioId)
                            )
                            this.usuariosAssociadosSelecionados = []
                            this.$toast.success(
                                'Usuários desassociados com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )
                        } else {
                            this.$toast.error(
                                response.errors,
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
            } else {
                this.usuariosAssociados = this.usuariosAssociados.filter(
                    usuario => !this.usuariosAssociadosSelecionados.includes(usuario.usuarioId)
                )

                this.usuariosAssociadosSelecionados = []
            }
        },

        marcarDesmarcarTodosAssociados() {
            if (this.usuariosAssociadosSelecionados.length === this.usuariosAssociados.length) {
                this.usuariosAssociadosSelecionados = []
            } else {
                this.usuariosAssociadosSelecionados = this.usuariosAssociados.map(
                    usuario => usuario.usuarioId
                )
            }
        },

        marcarDesmarcarTodosDisponiveis() {
            if (this.usuariosDisponiveisSelecionados.length === this.usuariosDisponiveis.length) {
                this.usuariosDisponiveisSelecionados = []
            } else {
                this.usuariosDisponiveisSelecionados = this.usuariosDisponiveis.map(
                    usuario => usuario.usuarioId
                )
            }
        },

        obterOpcoes() {
            this.$store.dispatch('addRequest')
            PreContratoServicos.obterOpcoes().then(
                (response) => {
                    if (response) {
                        if (response.success) {
                            let tiposContratacaoLocal = response.data.tiposContratacao
                            this.tiposContratacao = tiposContratacaoLocal.filter(item => !this.tiposContratacaoRemovidos.some(itemRemovido => itemRemovido.id === item.id))

                            let tiposLicitacaoLocal = response.data.tiposLicitacao
                            this.tiposLicitacao = tiposLicitacaoLocal.filter(item => this.tiposLicitacaoMantidos.some(itemMantido => itemMantido.id === item.id))
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        obterContrato() {
            this.$store.dispatch('addRequest')
            PreContratoServicos.obterPorId(this.$route.params.contratoId).then(
                (response) => {
                    if (response) {
                        if (response.success) {
                            this.contrato = response.data
                            this.converterContratoParaPrecontrato(this.contrato)
                            if (
                                this.preContratoDto.idSituacaoContrato ==
                                situacaoContrato.PRE_CONTRATO_CONCLUIDO
                            ) {
                                this.habilitaCampos = false
                                this.mudarTextoOperacao()
                            }
                            this.obterUsuariosAssociados()
                        } else {
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        obterUsuariosAssociados() {
            if (!this.$route.params.contratoId) {
                return
            }
            this.$store.dispatch('addRequest')
            PreContratoServicos.obterUsuariosPorContrato(this.$route.params.contratoId).then(
                (response) => {
                    if (response) {
                        if (Array.isArray(response)) {
                            this.usuariosAssociados = response
                        } else if (response.success) {
                            this.usuariosAssociados = Array.isArray(response.data) ? response.data : []
                        } else {
                            this.$toast.error(
                                response.errors || 'Erro ao obter usuários associados',
                                'ERROR',
                                this.$toastConfig.error
                            )
                            this.usuariosAssociados = []
                        }
                    } else {
                        this.usuariosAssociados = []
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        converterContratoParaPrecontrato(contrato) {
            this.preContratoDto.idContrato = contrato.idContrato
            this.preContratoDto.vcCodigoEstruturado =
                contrato.vcCodigoEstruturado

            this.preContratoDto.tpContratacao = contrato.tpContratacao

            if (this.preContratoDto.tpContratacao != 2) {
                this.selecionaTipoContratacao(this.preContratoDto.tpContratacao)

                this.preContratoDto.dataAutorizacaoMapa = this.$moment(
                    contrato.dataAutorizacaoMapa
                )
                this.preContratoDto.formaAutorizacao = contrato.formaAutorizacao
                this.preContratoDto.vcProcessoAditivo =
                    contrato.vcProcessoAditivo
            }

            this.preContratoDto.codTipoLicitacao = contrato.codTipoLicitacao
            this.preContratoDto.vcObjetoContrato = contrato.vcObjetoContrato
            this.preContratoDto.vcReferencia = contrato.vcReferencia || ''
            this.preContratoDto.codFornecedor = contrato.codFornecedor
            this.preContratoDto.nomeFornecedor = contrato.nomeFornecedor
            this.fornecedor.cnpjcpf = contrato.fornecedor.cnpj
            this.fornecedor.razaoSocial = contrato.fornecedor.nome
            this.preContratoDto.itensContrato = contrato.itensContrato
            this.preContratoDto.idSituacaoContrato = contrato.idSituacaoContrato
            this.preContratoDto.numProcessoLicitacao = contrato.numProcessoLicitacao
            this.preContratoDto.dataDePublicacaoDoDOE = this.$moment(contrato.dataDePublicacaoDoDOE).format('DD/MM/YYYY')
            this.preContratoDto.dataDePublicacaoDoDOU = contrato.dataDePublicacaoDoDOU ?
                                                        this.$moment(contrato.dataDePublicacaoDoDOU).format('DD/MM/YYYY') :
                                                        ""
            this.preContratoDto.arquivoAnexoDoDOE = contrato.nomeAnexoDoDOE
            this.preContratoDto.arquivoAnexoDoDOU = contrato.nomeAnexoDoDOU
            this.placeholderDOE = contrato.nomeAnexoDoDOE
            this.placeholderDOU = contrato.nomeAnexoDoDOU
            this.preContratoDto.CNO = contrato.cno !== null && contrato.cno !== undefined ? String(contrato.cno) : ''
            this.preContratoDto.ART = contrato.art !== null && contrato.art !== undefined ? String(contrato.art) : ''
            this.edicaoPreContrato = true
            this.$nextTick(() => this.verificarFornecedorLicitacao())
        },

        pesquisarFornecedor() {
            if (
                this.fornecedor.cnpjcpf.length == 14 ||
                this.fornecedor.cnpjcpf.length == 18
            ) {
                let cpfcnpjSemCaracteresEspeciais =
                    this.fornecedor.cnpjcpf.replace(/\D+/g, '')
                this.$store.dispatch('addRequest')
                PreContratoServicos.obterFornecedor(
                    cpfcnpjSemCaracteresEspeciais
                ).then((response) => {
                    if (response) {
                        if (response.success && response.data != null) {
                            this.erroFornecedor = null
                            this.fornecedor.razaoSocial = response.data.nome
                            this.preContratoDto.codFornecedor = response.data.codFornecedor
                            this.preContratoDto.nomeFornecedor = response.data.nome
                        } else {
                            this.erroFornecedor = 'Fornecedor não encontrado'
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
            }
        },

        onNumeroLicitacaoInput() {
            this.$v.preContratoDto.numProcessoLicitacao.$touch()
            this.$nextTick(() => {
                if (
                    this.preContratoDto.numProcessoLicitacao &&
                    this.preContratoDto.numProcessoLicitacao.length === 12
                ) {
                    this.verificarFornecedorLicitacao()
                }
            })
        },

        onCpfCnpjInput() {
            this.$v.fornecedor.cnpjcpf.$touch()
            this.$nextTick(() => {
                if (
                    this.fornecedor.cnpjcpf.length === 14 ||
                    this.fornecedor.cnpjcpf.length === 18
                ) {
                    this.verificarFornecedorLicitacao()
                }
            })
        },

        verificarFornecedorLicitacao() {
            const cnpjcpfCompleto = this.fornecedor.cnpjcpf.length === 14 || this.fornecedor.cnpjcpf.length === 18
            if (
                this.isTermoCadastramento ||
                !this.preContratoDto.numProcessoLicitacao ||
                this.preContratoDto.numProcessoLicitacao.length !== 12 ||
                !cnpjcpfCompleto
            ) {
                return
            }

            if (this.verificandoLicitacao) return
            this.verificandoLicitacao = true

            const cpfCnpjLimpo = this.fornecedor.cnpjcpf.replace(/\D+/g, '')
            this.fornecedorLicitacaoValido = null
            this.fornecedorLicitacaoConflito = false
            this.erroLicitacao = null

            this.$store.dispatch('addRequest')
            PreContratoServicos.verificarFornecedorLicitacao(
                this.preContratoDto.numProcessoLicitacao,
                cpfCnpjLimpo,
                this.preContratoDto.idContrato
            ).then((response) => {
                this.verificandoLicitacao = false
                if (response && response.success) {
                    this.fornecedorLicitacaoValido = response.data.valido
                    this.fornecedorLicitacaoConflito = response.data.eConflito === true
                    const deveExibirErro = !response.data.valido && response.data.mensagem
                        && (this.temBoletimMedicao || response.data.eConflito)
                    if (deveExibirErro) {
                        this.erroLicitacao = response.data.mensagem
                    }
                } else {
                    this.fornecedorLicitacaoValido = true
                    this.fornecedorLicitacaoConflito = false
                }
                this.$store.dispatch('removeRequest')
            })
        },

        salvarItemContrato(item) {

            if (this.preContratoDto.idContrato == '00000000-0000-0000-0000-000000000000') {
                this.preContratoDto.itensContrato.push(item)
                if (!this.$v.$invalid) {
                    this.salvarForm()
                }else{
                    this.preContratoDto.itensContrato = []
                }
            } else {
                this.inserirItemContrato(item)
            }
        },

        obterItensContrato() {
            if (this.preContratoDto.idContrato != 0) {
                PreContratoServicos.obterItensContrato(
                    this.preContratoDto.idContrato
                ).then((response) => {
                    if (response) {
                        if (response.success) {
                            this.preContratoDto.itensContrato = response.data
                        }
                    }
                })
            }
        },

        confirmarRemocaoItemContrato(item) {
            if (this.habilitaCampos) {
                this.$swal({
                    title: 'Excluir item contrato',
                    html: `Confirma a exclusão do item do contrato?
                <br/><br/><div class="alert alert-danger" role="alert">
                        Atenção! Essa é uma operação irreversível!
                    </div>`,
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Sim',
                    cancelButtonText: 'Não'
                }).then((result) => {
                    if (result.value) {
                        this.removerItemContrato(item)
                    }
                })
            }
        },

        removerItemContrato(item) {
            this.$store.dispatch('addRequest')
            PreContratoServicos.removerItemContrato(
                item.idContrato,
                item.itemContratoId
            ).then((response) => {
                if (response) {
                    if (response.success) {
                        this.preContratoDto.itensContrato = response.data
                        this.$toast.success(
                            'Item contrato removido com sucesso!',
                            'OK',
                            this.$toastConfig.success
                        )
                    } else {
                        this.$toast.error(response.errors, 'ERROR', this.error)
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        inserirItemContrato(itemContato) {
            itemContato.idContrato = this.preContratoDto.idContrato
            this.$store.dispatch('addRequest')
            PreContratoServicos.inserirItemContrato(itemContato).then(
                (response) => {
                    if (response) {
                        if (response.success) {
                            this.preContratoDto.itensContrato = response.data

                            this.$toast.success(
                                'Item adicionado com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.preContratoSalvo = true
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        atualizarItemContrato(itemContato) {
            itemContato.idContrato = this.preContratoDto.idContrato
            this.$store.dispatch('addRequest')
            PreContratoServicos.atualizarItemContrato(itemContato).then(
                (response) => {
                    if (response) {
                        if (response.success) {
                            this.preContratoDto.itensContrato = response.data

                            this.$toast.success(
                                'Item atualizado com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        quantidadeSubItens() {
            this.preContratoDto.itensContrato = []
            this.obterItensContrato()
        },

        calculaValoresItemContrato() {
            let valor = this.preContratoDto.itensContrato.reduce(
                (soma, item) => soma + item.valorUnitario,
                0
            )
            this.preContratoDto.nuSaldoContrato = valor
            this.preContratoDto.nuValorGlobalContrato = valor
        },

        selecionaTipoContratacao(value) {
            if (value == 1 || value == 3 || value == 4 || value == 5) {
                this.mostraFormaAutorizacao = true
                this.mostraNumeroMapa = false
                this.mostraPesquisaAtaESelecaoDeProcesso = false
                this.numeroMapa = ''
                this.preContratoDto.vcProcessoAditivo = ''
                if (value == 3) {
                    this.mostraNumeroMapa = true
                }
                if (value == 5) {
                    this.preContratoDto.numProcessoLicitacao =
                        'TERMO CADASTRAMENTO'
                }
            } else {
                this.mostraFormaAutorizacao = false
                this.mostraNumeroMapa = false
                this.preContratoDto.dataAutorizacaoMapa = null
                this.mostraPesquisaAtaESelecaoDeProcesso = true
                this.preContratoDto.vcProcessoAditivo = ''
            }
            this.formaAutorizacao = 0
        },

        mudarLabelReferenteLicitacao(value) {
            this.tipoLicitacaoSelecionado = this.tiposLicitacao.find(
                (x) => x.id == value
            ).descricao
        },

        salvarForm() {
            this.calculaValoresItemContrato()

            this.preContratoDto.dataAutorizacaoMapa = this.preContratoDto.dataAutorizacaoMapa
            ? this.$moment(this.preContratoDto.dataAutorizacaoMapa, ["DD/MM/YYYY", "YYYY-MM-DD"], true).isValid()
            ? this.$moment(this.preContratoDto.dataAutorizacaoMapa, "DD/MM/YYYY").format("YYYY-MM-DD")
            : ""
            : "";

            this.preContratoDto.dataDePublicacaoDoDOE = this.preContratoDto.dataDePublicacaoDoDOE
            ? this.$moment(this.preContratoDto.dataDePublicacaoDoDOE, ["DD/MM/YYYY", "YYYY-MM-DD"], true).isValid()
            ? this.$moment(this.preContratoDto.dataDePublicacaoDoDOE, "DD/MM/YYYY").format("YYYY-MM-DD")
            : ""
            : "";

            this.preContratoDto.dataDePublicacaoDoDOU = this.preContratoDto.dataDePublicacaoDoDOU
            ? this.$moment(this.preContratoDto.dataDePublicacaoDoDOU, ["DD/MM/YYYY", "YYYY-MM-DD"], true).isValid()
            ? this.$moment(this.preContratoDto.dataDePublicacaoDoDOU, "DD/MM/YYYY").format("YYYY-MM-DD")
            : ""
            : "";

            if (this.preContratoDto.tpContratacao == 5) {
                this.preContratoDto.codTipoLicitacao = 8
            }

            this.preContratoDto.usuarios = this.usuariosAssociados && this.usuariosAssociados.length > 0
                ? this.usuariosAssociados
                : []

            if (this.preContratoDto.idContrato != '00000000-0000-0000-0000-000000000000') {
                this.$store.dispatch('addRequest')
                PreContratoServicos.atualizarPreContrato(
                    this.preContratoDto
                ).then((response) => {
                    if (response) {
                        if (response.success) {
                            if (
                                this.preContratoDto.idSituacaoContrato ==
                                situacaoContrato.PRE_CONTRATO_EM_ELABORACAO
                            ) {
                                if (
                                    this.preContratoDto.dataAutorizacaoMapa !=
                                    null
                                ) {
                                    this.preContratoDto.dataAutorizacaoMapa =
                                        this.$moment(
                                            this.preContratoDto
                                                .dataAutorizacaoMapa
                                        ).format('DD/MM/YYYY')
                                }
                                if (
                                    this.preContratoDto.dataDePublicacaoDoDOE !=
                                    null
                                ) {
                                    this.preContratoDto.dataDePublicacaoDoDOE =
                                        this.$moment(
                                            this.preContratoDto
                                                .dataDePublicacaoDoDOE
                                        ).format('DD/MM/YYYY')
                                }
                                if (
                                    this.preContratoDto.dataDePublicacaoDoDOU !=
                                    null
                                ) {
                                    this.preContratoDto.dataDePublicacaoDoDOU =
                                        this.$moment(
                                            this.preContratoDto
                                                .dataDePublicacaoDoDOU
                                        ).format('DD/MM/YYYY')
                                }
                                this.$toast.success(
                                    'Pré contrato atualizado com sucesso!',
                                    'OK',
                                    this.$toastConfig.success
                                )
                            } else {
                                this.$toast.success(
                                    'Pré contrato concluído!',
                                    'OK',
                                    this.$toastConfig.success
                                )
                                this.mudarTextoOperacao()
                                this.redirecionarParaDetalharSeConcluir()
                            }
                            this.preContratoSalvo = true
                        } else {
                            this.redirecionarParaDetalharAoConcluir = false
                            this.erros = response.errors
                            if (
                                this.preContratoDto.dataAutorizacaoMapa != null
                            ) {
                                this.preContratoDto.dataAutorizacaoMapa =
                                    this.$moment(
                                        this.preContratoDto.dataAutorizacaoMapa,
                                        'YYYY-MM-DD'
                                    ).format('DD/MM/YYYY')
                            }
                            if (
                                    this.preContratoDto.dataDePublicacaoDoDOE !=
                                    null
                                ) {
                                    this.preContratoDto.dataDePublicacaoDoDOE =
                                        this.$moment(
                                            this.preContratoDto
                                                .dataDePublicacaoDoDOE
                                        ).format('DD/MM/YYYY')
                                }
                                if (
                                    this.preContratoDto.dataDePublicacaoDoDOU !=
                                    null
                                ) {
                                    this.preContratoDto.dataDePublicacaoDoDOU =
                                        this.$moment(
                                            this.preContratoDto
                                                .dataDePublicacaoDoDOU
                                        ).format('DD/MM/YYYY')
                                }
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
            } else {
                this.$store.dispatch('addRequest')
                PreContratoServicos.inserirPreContrato(
                    this.preContratoDto
                ).then((response) => {
                    if (response) {
                        if (response.success) {
                            this.preContratoDto.itensContrato =
                                response.data.itensContrato
                            this.preContratoDto.idContrato =
                                response.data.idContrato

                            if (
                                this.preContratoDto.idSituacaoContrato ==
                                situacaoContrato.PRE_CONTRATO_EM_ELABORACAO
                            ) {
                                if (
                                    this.preContratoDto.dataAutorizacaoMapa !=
                                    null
                                ) {
                                    this.preContratoDto.dataAutorizacaoMapa =
                                        this.$moment(
                                            this.preContratoDto
                                                .dataAutorizacaoMapa
                                        ).format('DD/MM/YYYY')
                                }
                                if (
                                    this.preContratoDto.dataDePublicacaoDoDOE !=
                                    null
                                ) {
                                    this.preContratoDto.dataDePublicacaoDoDOE =
                                        this.$moment(
                                            this.preContratoDto
                                                .dataDePublicacaoDoDOE
                                        ).format('DD/MM/YYYY')
                                }
                                if (
                                    this.preContratoDto.dataDePublicacaoDoDOU !=
                                    null
                                ) {
                                    this.preContratoDto.dataDePublicacaoDoDOU =
                                        this.$moment(
                                            this.preContratoDto
                                                .dataDePublicacaoDoDOU
                                        ).format('DD/MM/YYYY')
                                }
                                this.$toast.success(
                                    'Pré contrato salvo com sucesso!',
                                    'OK',
                                    this.$toastConfig.success
                                )
                                this.habilitaCampos = true
                            } else {
                                this.$toast.success(
                                    'Pré contrato concluído!',
                                    'OK',
                                    this.$toastConfig.success
                                )
                                this.mudarTextoOperacao()
                                this.redirecionarParaDetalharSeConcluir()
                            }
                            this.preContratoSalvo = true
                            this.erros = []
                        } else {
                            this.redirecionarParaDetalharAoConcluir = false
                            this.habilitaCampos = true
                            this.erros = response.errors
                            this.preContratoDto.idSituacaoContrato = 3
                            if (
                                this.preContratoDto.dataAutorizacaoMapa != null
                            ) {
                                this.preContratoDto.dataAutorizacaoMapa =
                                    this.$moment(
                                        this.preContratoDto.dataAutorizacaoMapa,
                                        'YYYY-MM-DD'
                                    ).format('DD/MM/YYYY')
                            }
                            if (
                                this.preContratoDto.dataDePublicacaoDoDOE != null
                            ) {
                                this.preContratoDto.dataDePublicacaoDoDOE =
                                    this.$moment(
                                        this.preContratoDto.dataDePublicacaoDoDOE,
                                        'YYYY-MM-DD'
                                    ).format('DD/MM/YYYY')
                            }
                            if (
                                this.preContratoDto.dataDePublicacaoDoDOU != null
                            ) {
                                this.preContratoDto.dataDePublicacaoDoDOU =
                                    this.$moment(
                                        this.preContratoDto.dataDePublicacaoDoDOU,
                                        'YYYY-MM-DD'
                                    ).format('DD/MM/YYYY')
                            }
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
            }
        },

        mudarTextoOperacao() {
            if (this.$route.params.contratoId) {
                this.operacao = 'EDIÇÃO'
            }

            if (
                this.preContratoDto.idSituacaoContrato ==
                situacaoContrato.PRE_CONTRATO_CONCLUIDO
            ) {
                this.operacao = 'CONCLUÍDO'
            }
        },

        cancelar() {
            this.erros = []
            if (this.preContratoSalvo) {
                this.$store.dispatch('setRecarregar', true)
            }
            this.$router.push({ name: 'Contratos' })
        },

        confirmarConcluir() {
            this.$swal({
                title: 'Pré-contrato',
                html: `Confirma a conclusão do pré-contrato <b>${this.preContratoDto.vcCodigoEstruturado}</b>?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.concluir()
                }
            })
        },

        concluir() {
            this.redirecionarParaDetalharAoConcluir = true
            this.preContratoDto.idSituacaoContrato =
                situacaoContrato.PRE_CONTRATO_CONCLUIDO
            this.salvarForm()
            this.habilitaCampos = false
        },

        tipoContratacaoEscolhida() {
            if (this.preContratoDto.tpContratacao == 2 || this.preContratoDto.tpContratacao == 6 || this.preContratoDto.tpContratacao == 7 ||
            this.preContratoDto.tpContratacao == 8 || this.preContratoDto.tpContratacao == 9 || this.preContratoDto.tpContratacao == 10 ||
            this.preContratoDto.tpContratacao == 11 || this.preContratoDto.tpContratacao == 12
            ) {
                return true
            } else if (
                this.preContratoDto.tpContratacao != 2 &&
                this.preContratoDto.dataAutorizacaoMapa != null &&
                this.preContratoDto.formaAutorizacao != 0
            ) {
                return true
            }
            return false
        },

        dataDePublicacaoDoDouExiste() {
            if (this.preContratoDto.dataDePublicacaoDoDOU === "" || this.preContratoDto.dataDePublicacaoDoDOU === null || this.preContratoDto.dataDePublicacaoDoDOU === "Invalid date") {
                return true;
            } else {
                if (this.preContratoDto.arquivoAnexoDoDOU !== null && this.preContratoDto.arquivoAnexoDoDOU !== "") {
                    return true;
                } else {
                    return false;
                }
            }
        },

        validaTamanhoCpfCnpj() {
            return (
                this.fornecedor.cnpjcpf.length == '14' ||
                this.fornecedor.cnpjcpf.length == '18'
            )
        },

        onAnexoInput(file, campo, ref) {
            if (file && file.type !== 'application/pdf') {
                this.$toast.error('Apenas arquivos PDF são permitidos', 'ERROR', this.$toastConfig.error)
                this.preContratoDto[campo] = null
                this.$nextTick(() => this.$refs[ref].reset())
                return
            }

            this.$v.preContratoDto[campo].$touch()
        },

        downloadAnexoDoe() {
            this.$store.dispatch('addRequest')
            PreContratoServicos.downloadAnexoDoe(this.contrato).then(response => {
                if (response) {
                    if (response.type === 'application/json') {
                        this.$toast.error(
                            'Erro ao realizar download do arquivo!!!',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    } else {
                        this.$download(response, this.contrato.nomeAnexoDoDOE)
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        downloadAnexoDou() {
            this.$store.dispatch('addRequest')
            PreContratoServicos.downloadAnexoDou(this.contrato).then(response => {
                if (response) {
                    if (response.type === 'application/json') {
                        this.$toast.error(
                            'Erro ao realizar download do arquivo!!!',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    } else {
                        this.$download(response, this.contrato.nomeAnexoDoDOU)
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },
    },

    created() {
        this.obterOpcoes()
        this.obterUsuarios()
        if (this.$route.params.contratoId) {
            this.mudarTextoOperacao()
            this.textoBotao = 'Atualizar'

            this.obterContrato()
        }
    },

    watch: {
        'preContratoDto.numProcessoLicitacao'() {
            this.fornecedorLicitacaoValido = null
            this.verificandoLicitacao = false
            this.erroLicitacao = null
        },
        'fornecedor.cnpjcpf'() {
            this.fornecedorLicitacaoValido = null
            this.verificandoLicitacao = false
            this.erroLicitacao = null
        },
        temBoletimMedicao() {
            this.fornecedorLicitacaoValido = null
            this.fornecedorLicitacaoConflito = false
            this.verificandoLicitacao = false
            this.erroLicitacao = null
            this.$nextTick(() => this.verificarFornecedorLicitacao())
        }
    },

    computed: {
        todosOsErros() {
            return [
                ...this.erros,
                ...(this.erroFornecedor ? [this.erroFornecedor] : []),
                ...(this.erroLicitacao ? [this.erroLicitacao] : []),
            ]
        },

        habilitarSalvar() {
            if (this.$v.$invalid) return false

            const cnpjcpfCompleto = this.fornecedor.cnpjcpf.length === 14 || this.fornecedor.cnpjcpf.length === 18
            const deveVerificar = !this.isTermoCadastramento
                && this.preContratoDto.numProcessoLicitacao
                && this.preContratoDto.numProcessoLicitacao.length === 12
                && cnpjcpfCompleto

            if (deveVerificar) {
                if (this.temBoletimMedicao && this.fornecedorLicitacaoValido !== true) return false
                if (!this.temBoletimMedicao && this.fornecedorLicitacaoConflito === true) return false
            }

            return true
        },

        isTermoCadastramento() {
            return this.preContratoDto.tpContratacao == 5
        },

        permiteEditarExcluir() {
            return this.preContratoDto.idSituacaoContrato != situacaoContrato.PRE_CONTRATO_CONCLUIDO
        },
        camposVazios() {
            return (this.preContratoDto.vcCodigoEstruturado != '' &&
                (this.preContratoDto.numProcessoLicitacao != null && this.preContratoDto.numProcessoLicitacao != '') &&
                this.preContratoDto.vcObjetoContrato != '' &&
                this.preContratoDto.codFornecedor != '' &&
                this.tipoContratacaoEscolhida())
        },
        usuariosDisponiveis() {
            if (this.usuarios && this.usuariosAssociados) {
                return this.usuarios.filter(usuario => {
                    return this.usuariosAssociados.every(usuarioAssociado => {
                        return usuarioAssociado.usuarioId !== usuario.usuarioId
                    })
                })
            }
            return this.usuarios || []
        }
    },

    validations: {
        preContratoDto: {
            vcCodigoEstruturado: {
                required
            },
            numProcessoLicitacao: {
                required
            },
            dataAutorizacaoMapa: {
                tipoContratacao() {
                    return this.tipoContratacaoEscolhida()
                }
            },
            vcObjetoContrato: {
                required,
                maxLength: maxLength(1000)
            },
            dataDePublicacaoDoDOE: {
                required
            },
            arquivoAnexoDoDOE: {
                required
            },
            arquivoAnexoDoDOU: {
                dataDePublicacaoDoDOU() {
                    return this.dataDePublicacaoDoDouExiste();
                }
            }
        },
        fornecedor: {
            cnpjcpf: {
                required,
                validaCpfCnpj() {
                    return this.validaTamanhoCpfCnpj()
                }
            },
            razaoSocial: {
                required
            }
        }
    }
}
</script>

<style>
    .publicacao-coluna {
        display: flex;
        flex-direction: column;
        gap: 12px;
    }

    .publicacao-anexo-item {
        display: flex;
        align-items: flex-end;
        gap: 8px;
        min-width: 0;
    }

    .publicacao-anexo-item .form-group {
        flex: 1 1 auto;
        min-width: 0;
    }

    .publicacao-anexo-item .custom-file-label {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        padding-right: 90px;
    }

    .tabela-usuarios-container {
        position: relative;
        max-height: 500px;
        overflow-y: auto;
        overflow-x: hidden;
    }

    .tabela-usuarios-container > div > .row:first-child {
        position: sticky;
        top: 0;
        background-color: #fff;
        z-index: 10;
        padding: 10px 0;
        margin: 0;
        border-bottom: 1px solid #dee2e6;
    }
    .tabela-usuarios-container > div > table {
        margin-bottom: 0;
    }
    .tabela-usuarios-container > div > table thead {
        position: sticky;
        top: 60px;
        background-color: #fff;
        z-index: 9;
    }
</style>
